<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22.6666C17.891 22.6666 22.6667 17.891 22.6667 12C22.6667 6.10894 17.891 1.33331 12 1.33331C6.10896 1.33331 1.33333 6.10894 1.33333 12C1.33333 17.891 6.10896 22.6666 12 22.6666Z"/>
</svg>
